"use strict";

var ubian = ubian || {};

ubian.settings = {
  save: function() {
    var data = $(".js-settings input").serialize();
    $.post(ubian.routes["user_settings_save"], data, function() {
      ubian.utils.alert(ubian.translate("JS.Settings.Saved"));
    });
  }
};

$(function() {
  $(".js-save-settings").click(ubian.settings.save);
});
